import { observer } from 'mobx-react-lite';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { mergeQueryString } from 'bernie-core';
import { UitkSelect } from 'uitk-react-input';
import { useStores } from '../../../utils/hooks';
export var Dropdown = observer(function (_a) {
  var _b;
  var field = _a.field,
    inDialog = _a.inDialog,
    title = _a.title;
  var _c = useStores(),
    analytics = _c.analytics,
    activitySearchStore = _c.activitySearchStore,
    searchCriteriaStore = _c.searchCriteriaStore;
  var history = useHistory();
  var location = useLocation();
  var selectedSortValue = (_b = field.options.find(function (option) {
    return option.selected;
  })) === null || _b === void 0 ? void 0 : _b.value;
  var dropDownRef = React.createRef();
  var changeHandler = function (event) {
    activitySearchStore.searchSetup();
    var selectedIndex = event.target.selectedIndex;
    var selectAnalytics = field.options[selectedIndex].selectAnalytics;
    field.options.forEach(function (option) {
      option.selected = false;
    });
    field.options[selectedIndex].selected = true;
    activitySearchStore.sortAndFilterObject.initialSelectedSort = field.options[selectedIndex].value;
    analytics.trackEvent(selectAnalytics.referrerId, selectAnalytics.linkName, analytics.omnitureData);
    if (!inDialog) {
      var newQueryString = mergeQueryString(location.search, {
        sort: field.options[selectedIndex].value
      });
      history.push({
        pathname: location.pathname,
        search: newQueryString,
        state: {}
      });
    }
  };
  React.useEffect(function () {
    var _a;
    if (searchCriteriaStore.pillRemoveIndex !== null) {
      if (searchCriteriaStore.pillRemoveIndex === -1) {
        (_a = dropDownRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        searchCriteriaStore.pillRemoveIndex = null;
      }
    }
  }, []);
  return React.createElement(UitkSelect, {
    id: "sort-select",
    "data-testid": "sort-dropdown",
    label: title || '',
    value: selectedSortValue,
    onChange: changeHandler,
    domRef: dropDownRef
  }, field === null || field === void 0 ? void 0 : field.options.map(function (option, optionIndex) {
    var value = option.value,
      primary = option.primary,
      selected = option.selected,
      disabled = option.disabled;
    return React.createElement("option", {
      "data-testid": "sort-".concat(value),
      key: optionIndex,
      value: value,
      "aria-selected": selected,
      disabled: disabled
    }, primary);
  }));
});